var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRadio = function SvgRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.763 7.527a5 5 0 0 0 0 8.946l-.894 1.79A7 7 0 0 1 5 12a7 7 0 0 1 3.869-6.262zm4.474 0a5 5 0 0 1 0 8.946l.894 1.79A7 7 0 0 0 19 12a7 7 0 0 0-3.869-6.262zm1.789-3.579A9 9 0 0 1 21 12a9 9 0 0 1-4.974 8.052l.894 1.789A11 11 0 0 0 23 12a11 11 0 0 0-6.08-9.84zM7.08 2.16A11 11 0 0 0 1 12a11 11 0 0 0 6.08 9.84l.894-1.788A9 9 0 0 1 3 12a9 9 0 0 1 4.974-8.052z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "currentColor"
  })));
};
export default SvgRadio;